<div class="history">
  <div class="history-title">
    <div class="history-title-name">
      {{'CONTRACTS.CARD.HISTORY_TITLE'|translate}}
    </div>
    <div class="history-title-items-count">
      {{versions?.length}}{{this.savedCountLabel}}
    </div>
  </div>
  <mat-list *ngIf="versions" class="history-list" >
    @for (version of versions; track version.id) {
      <mat-list-item class="history-list-item" 
        (click)="selectVersion(version)" data-action="selectVersion"
        [class.selected-rm]="version.id === selectedVersion" >
        <div class="history-list-item-wrap">
          <div class="history-list-item-data">
            <div class="history-list-item-data-date">
              {{dateLabelsMap.get(version.id)}} {{$index===0? '(Текущая версия)':''}}
            </div>
            <div class="history-list-item-data-user">
              <app-contract-avatar class="history-list-item-data-user-avatar" 
              [userGuid]="version.owner.guid" 
              [avatarSize]="'30px'">
            </app-contract-avatar>
            <div class="history-list-item-data-user-name">
              <span> {{version.name}}</span>
              <span>{{userNamesMap.get(version.owner.guid)}}</span>
            </div>
          </div>
          
        </div>
        <div *ngIf="version.id === selectedVersion" 
          class="action-icon contract-icon-confirm-circle history-list-item-icon"></div>
      </div>
      </mat-list-item>
    }
  </mat-list>
  <div class="history-buttons">
    <button class="button-icon size-l primary-button" data-action="restoreCurrentVersion" 
      [disabled]="!selectedVersion"
      (click)="restoreCurrentVersion()">
      <mat-icon svgIcon="arrow-go-back-fill"> </mat-icon>
      {{'CONTRACTS.CARD.RESTORE' | translate}}
    </button>
    <button class="button-icon size-l secondary-button" data-action="cancelAction" (click)="cancelAction()">
      <mat-icon svgIcon="close-fill"> </mat-icon>
      {{'CONTRACTS.CARD.CANCEL' | translate}}
    </button>
  </div>
</div>